import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="w-full bg-gray-800 text-white py-8 mt-12">
      <div className="max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center justify-between">
        <div className="mb-4 md:mb-0 text-center md:text-left">
          <p className="text-sm">
            Copyright &copy; 2025 <a href="https://tieupsolutions.com/" target="_blank" rel="noopener noreferrer" className="hover:underline font-semibold">Tieup Solutions Pvt Ltd</a>. All Rights Reserved.
          </p>
        </div>
        <div className="flex gap-6">
          <Link to="/terms" className="hover:underline">Terms and Conditions</Link>
          <Link to="/privacy" className="hover:underline">Privacy Policy and Refund Policy</Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
